export default {
  common: {
    accountScreen: {
      errors: {
        aborted: "Pas d'abonnement en cours pour ce compte",
      },
    },
  },
}
